// Pure dnd-id helper for the Kanban board. DOM-free (no React/dnd-kit), so the
// id grammar can be exercised directly without mounting a board.

import type { Id } from './types';

/**
 * The dnd-kit draggable/sortable id for a card. dnd-kit keys its draggable-node
 * map by a single id shared across the whole DndContext, so the id MUST be
 * unique per rendered card — not just per item. In multi-membership groupings
 * (team, assignee) the SAME item appears in several columns at once; keying by
 * item id alone collides, and the active node resolves to whichever copy
 * registered last (the rightmost column) instead of the card the user grabbed.
 * Scoping the id by column keeps every copy distinct.
 */
export function cardDndId(columnId: Id, itemId: Id): string {
  return `${columnId}::${itemId}`;
}
